// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_eYG","cls2":"SearchBox-cls2_kP6 SearchBox-cls1_eYG"};